import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeTestComponent } from './badge-test.component';
import { MatChipsModule } from "@angular/material/chips";

@NgModule({
  declarations: [BadgeTestComponent],
  imports: [
    CommonModule,
    MatChipsModule,
  ],
  exports : [BadgeTestComponent]
})
export class BadgeTestModule { }
